(function () {
  'use strict';

  var staffPickSelector = '.fordeer-config-label .fordeer-text-wrap';
  var cartButtonSelector = '[data-add-to-cart]';
  var productCardSelector = '.grid-product, .cbb-also-bought-product, .ba-product, ' +
    '.boost-sd__product-item, .boost-sd__suggestion-queries-item';
  var boostPriceSelector = '.boost-sd__product-price, .boost-sd__suggestion-queries-item-price, .boost-sd__quick-view-price';

  function priceCents(value) {
    var match = String(value || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return match ? Math.round(parseFloat(match[0]) * 100) : null;
  }

  function syncBoostPrice(price) {
    var pricing = window.dwMemberPricing || {};
    var labels = pricing.labels || {};
    if (price.matches('.boost-sd__suggestion-queries-item-price')) {
      price.querySelectorAll('.boost-sd__format-currency, .boost-sd__format-currency *').forEach(function (amount) {
        if (amount.children.length) return;
        var currentText = amount.textContent;
        var formattedText = currentText.replace(/(\$\s*-?[\d,]+)(?:\.(\d{1,2}))?(?![\d,.])/g, function (match, dollars, cents) {
          return dollars + '.' + (cents || '').padEnd(2, '0');
        });
        if (formattedText === currentText) return;
        amount.textContent = formattedText;
        var label = amount.getAttribute('aria-label');
        if (label) amount.setAttribute('aria-label', label.replace(currentText.trim(), formattedText.trim()));
      });
    }
    var compare = price.querySelector('.boost-sd__format-currency--price-compare');
    var current = price.querySelector('.boost-sd__product-price--sale, .boost-sd__format-currency--price-sale, .boost-sd__product-price--default') ||
      price.querySelector('.boost-sd__format-currency:not(.boost-sd__format-currency--price-compare)');
    if (!current) return;

    var currentCents = priceCents(current.textContent);
    if (currentCents === null) return;
    var compareCents = priceCents(compare && compare.textContent);
    var qualifies = compareCents > currentCents && (compareCents - currentCents) * 100 >= compareCents * 2;
    var card = price.closest('.boost-sd__product-item, .boost-sd__suggestion-queries-item--product');
    var productNode = price.closest('[data-product]') || (card && card.querySelector('[data-product]'));
    if (productNode) {
      try {
        var tags = JSON.parse(productNode.getAttribute('data-product') || '{}').tags;
        if (!Array.isArray(tags)) tags = String(tags || '').split(',');
        if (tags.some(function (tag) { return /^(clearance|discontinued)$/i.test(String(tag).trim()); })) {
          markClearanceContext(price);
        }
      } catch (error) {}
    }
    var clearance = Boolean(price.closest('[data-dw-clearance-product="true"]'));
    var standard = !qualifies && !clearance;
    price.classList.toggle('dw-price-standard', standard);
    price.classList.remove('dw-price-quiet');
    if (card) card.classList.toggle('dw-product-price-standard', standard);
    if (compare) {
      if (standard && compare.getAttribute('aria-hidden') !== 'true') compare.setAttribute('aria-hidden', 'true');
      if (!standard && compare.hasAttribute('aria-hidden')) compare.removeAttribute('aria-hidden');
    }

    var priceLabel = standard ? (labels.regularPrice || 'Regular price') :
      clearance ? (labels.clearancePrice || 'Clearance price') :
      pricing.mode === 'open_sale' ? (labels.salePrice || 'Sale price') : (labels.memberPrice || 'Members price');
    var description = priceLabel + ' ' + current.textContent.trim();
    if (!standard && compare) description = (labels.regularPrice || 'Regular price') + ' ' + compare.textContent.trim() + ', ' + description;
    var accessible = price.querySelector('.boost-sd__visually-hidden');
    if (accessible && accessible.textContent.trim() !== description) accessible.textContent = description;
    current.querySelectorAll('[aria-label]').forEach(function (amount) {
      var value = priceLabel + ': ' + amount.textContent.trim();
      if (amount.getAttribute('aria-label') !== value) amount.setAttribute('aria-label', value);
    });
  }

  function markClearanceContext(label) {
    var context = label && label.closest(productCardSelector);

    if (!context) return;

    if (context.getAttribute('data-dw-clearance-product') !== 'true') {
      context.setAttribute('data-dw-clearance-product', 'true');
    }
    context.querySelectorAll(
      '.grid-product__member-label, .results-products__member-label, ' +
      '.cbb-member-label, .ba-product-member-label, .upcart-member-label'
    ).forEach(function (priceLabel) {
      var clearanceText = window.dwMemberPricing?.labels?.clearance || 'CLEARANCE';
      if (priceLabel.textContent !== clearanceText) priceLabel.textContent = clearanceText;
      if (!priceLabel.classList.contains('dw-price-label--clearance')) {
        priceLabel.classList.add('dw-price-label--clearance');
      }
    });
  }

  function classifyLabel(label) {
    var text = (label.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();
    var isStaffPick = text === 'staff pick';
    var isClearance = text === 'clearance' || text === 'discontinued';
    var isApprovedLabel = isStaffPick || isClearance;
    var container = label.closest('.fordeer-config-label');

    label.classList.toggle('dw-staff-pick-label', isStaffPick);
    label.classList.toggle('dw-clearance-label', isClearance);
    label.classList.toggle('dw-product-label--suppressed', !isApprovedLabel);

    if (container) {
      container.classList.toggle('dw-product-label--approved', isApprovedLabel);
      container.classList.toggle('dw-product-label--suppressed', !isApprovedLabel);
      if (isApprovedLabel) {
        if (container.hasAttribute('aria-hidden')) container.removeAttribute('aria-hidden');
      } else if (container.getAttribute('aria-hidden') !== 'true') {
        container.setAttribute('aria-hidden', 'true');
      }
    }

    if (isClearance) markClearanceContext(label);
  }

  function collectTargets(root, labels, buttons, prices, includeDescendants) {
    var scope = root && root.nodeType === 3 ? root.parentElement : root;
    var closestLabel;
    var closestButton;

    if (!scope || scope.nodeType !== 1) return;

    closestLabel = scope.closest(staffPickSelector);
    if (closestLabel) labels.add(closestLabel);
    closestButton = scope.closest(cartButtonSelector);
    if (closestButton) buttons.add(closestButton);
    var closestPrice = scope.closest(boostPriceSelector);
    if (closestPrice) prices.add(closestPrice);

    if (!includeDescendants) return;

    scope.querySelectorAll(staffPickSelector).forEach(function (label) { labels.add(label); });
    scope.querySelectorAll(cartButtonSelector).forEach(function (button) { buttons.add(button); });
    scope.querySelectorAll(boostPriceSelector).forEach(function (price) { prices.add(price); });
  }

  function syncTargets(labels, buttons, prices) {
    labels.forEach(classifyLabel);

    buttons.forEach(function (button) {
      var textNode = button.querySelector('[data-add-to-cart-text]');
      var label = ((textNode && textNode.textContent) || button.textContent || '').trim().toLowerCase();

      button.classList.toggle('dw-product-action--sold-out', label === 'sold out');
    });
    prices.forEach(syncBoostPrice);
  }

  function syncMutations(mutations) {
    var labels = new Set();
    var buttons = new Set();
    var prices = new Set();
    var roots = new Set();

    mutations.forEach(function (mutation) {
      var target = mutation.target.nodeType === 3 ? mutation.target.parentElement : mutation.target;
      var card = target && target.nodeType === 1 ? target.closest(productCardSelector) : null;

      collectTargets(target, labels, buttons, prices, false);
      if (card) roots.add(card);

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) roots.add(node);
      });
    });

    roots.forEach(function (root) {
      var parent = root.parentElement;

      if (!root.isConnected) return;
      while (parent) {
        if (roots.has(parent)) return;
        parent = parent.parentElement;
      }

      collectTargets(root, labels, buttons, prices, true);
    });

    syncTargets(labels, buttons, prices);
  }

  function start() {
    var labels = new Set();
    var buttons = new Set();
    var prices = new Set();
    collectTargets(document.body, labels, buttons, prices, true);
    syncTargets(labels, buttons, prices);

    new MutationObserver(syncMutations).observe(document.body, {
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-product', 'data-dw-clearance-product'],
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
